import { useFlag } from '@unleash/proxy-client-react'
import InfoIcon from '@mui/icons-material/InfoOutlined'
import { Tooltip } from '@mui/material'
import IconButton from '@mui/material/IconButton'
import { useParams } from 'react-router-dom'
import { activeAlbumIdVar, drawerVar } from '../../../../../providers/apollo/cache'
import useSelectedAlbums from '../../../hooks/useSelectedAlbums'

export default function AlbumDetailsIcon() {
  const { bucketId, albumId } = useParams<{ bucketId: string; albumId: string }>()
  const useUpdatedAlbumActions = useFlag('useUpdatedAlbumActions')
  const { selectedAlbums } = useSelectedAlbums()
  const containRootAlbum = Array.from(selectedAlbums.keys()).includes(bucketId as string)

  const toggleDrawer = () => {
    if (albumId) {
      activeAlbumIdVar(albumId)
    } else if (selectedAlbums.size > 0) {
      const firstAlbumId = Array.from(selectedAlbums.keys())[0]
      activeAlbumIdVar(firstAlbumId)
    }
    drawerVar('bucketAlbumDetails')
  }

  return (
    <IconButton
      aria-label="Album Details"
      color="primary"
      onClick={toggleDrawer}
      disabled={containRootAlbum || !(albumId || selectedAlbums.size === 1)}
      id="details-button"
      data-test="details-button"
      sx={{ padding: useUpdatedAlbumActions ? '4px' : '8px' }}
    >
      <Tooltip title="Album Details" arrow>
        <InfoIcon />
      </Tooltip>
    </IconButton>
  )
}
